// CODE GENERATED BY scripts/wb_codegen.mjs. DO NOT EDIT MANUALLY.
// Source: web/src/suites/webbuilder/blocks/manifest/*.block.json

export type BlockType = 'AccordionFAQ' | 'AdmissionsStatusTrackerBlock' | 'AppProductCatalogBlock' | 'Button' | 'CallToActionBanner' | 'CoachCourseCatalogBlock' | 'ConsentCheckboxBlock' | 'Container' | 'ConversionFormBlock' | 'CookieBannerBlock' | 'CountdownTimer' | 'DigitalProductCard' | 'DigitalProductList' | 'Divider' | 'FacultyShowcase' | 'FeePaymentPortalBlock' | 'Grid2Col' | 'Heading' | 'HeroSplit' | 'ImageGallery' | 'LegalAgreementBlock' | 'MathFormulaBlock' | 'Paragraph' | 'PricingTable' | 'RichTextBlock' | 'SchoolNoticeBoardBlock' | 'Section' | 'SiteFooter' | 'SiteNavbar' | 'Spacer' | 'StatsCounter' | 'StorefrontCheckoutBlock' | 'Testimonials' | 'TopperCard' | 'ToppersShowcase' | 'VideoPlayer';

export type BlockCategory =
  | 'layout'
  | 'typography'
  | 'media'
  | 'conversion'
  | 'erp_binding'
  | 'commerce'
  | 'academics'
  | 'legal';

export interface PropDefinition {
  type: 'string' | 'text' | 'richtext' | 'number' | 'boolean' | 'enum' | 'color' | 'image' | 'link' | 'icon' | 'date' | 'list' | 'object';
  default: unknown;
  control: 'text' | 'textarea' | 'richtext' | 'number' | 'switch' | 'select' | 'segmented' | 'color' | 'image' | 'link' | 'icon' | 'list';
  group: 'Content' | 'Style' | 'Layout' | 'Action' | 'Advanced' | 'Compliance';
  label?: string;
  description?: string;
  options?: string[];
  responsive?: boolean;
}

export interface BlockManifest {
  type: BlockType;
  title: string;
  category: BlockCategory;
  description: string;
  icon: string;
  version?: string;
  container?: boolean;
  allowedParents?: string[];
  allowedChildren?: string[];
  props: Record<string, PropDefinition>;
  styleControls?: string[];
  defaultStyles?: Record<string, unknown>;
  presets?: Array<{ name: string; props: Record<string, unknown> }>;
}

export const BLOCK_MANIFESTS: Record<BlockType, BlockManifest> = {
  "AccordionFAQ": {
    "type": "AccordionFAQ",
    "title": "FAQ Accordion",
    "category": "academics",
    "description": "Collapsible FAQ accordion with admissions, fees, and syllabus queries",
    "icon": "HelpCircle",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Frequently Asked Questions",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Everything you need to know about admissions, curriculum, and results.",
        "control": "textarea",
        "group": "Content"
      },
      "q1": {
        "type": "text",
        "default": "What is the admission and enrollment process?",
        "control": "text",
        "group": "Content"
      },
      "a1": {
        "type": "text",
        "default": "Admissions are granted based on the Entrance Diagnostic Test (EDT) or direct registration for foundation batches. Speak with our counselors to get started.",
        "control": "textarea",
        "group": "Content"
      },
      "q2": {
        "type": "text",
        "default": "Are study materials and test series included?",
        "control": "text",
        "group": "Content"
      },
      "a2": {
        "type": "text",
        "default": "Yes, all enrolled classroom and online students receive comprehensive module booklets, daily practice problems (DPPs), and national-level test series access.",
        "control": "textarea",
        "group": "Content"
      },
      "q3": {
        "type": "text",
        "default": "What are the typical batch timings and student-to-teacher ratio?",
        "control": "text",
        "group": "Content"
      },
      "a3": {
        "type": "text",
        "default": "We maintain an optimal ratio of 25:1 to ensure personalized attention and dedicated doubt-clearing sessions.",
        "control": "textarea",
        "group": "Content"
      },
      "q4": {
        "type": "text",
        "default": "Can I attend demo lectures before paying the tuition fees?",
        "control": "text",
        "group": "Content"
      },
      "a4": {
        "type": "text",
        "default": "Yes! We offer 2 complimentary trial lectures so students can experience our teaching methodology and faculty expertise first-hand.",
        "control": "textarea",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 24px 0"
      }
    },
    "presets": [
      {
        "name": "Institute FAQ",
        "props": {
          "headline": "Frequently Asked Questions"
        }
      }
    ]
  },
  "AdmissionsStatusTrackerBlock": {
    "type": "AdmissionsStatusTrackerBlock",
    "title": "Admissions Status Tracker",
    "category": "erp_binding",
    "description": "Applicant lookup portal for admission application tracking and merit list result",
    "icon": "SearchCheck",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Track Your Admission Application",
        "control": "text",
        "group": "Content"
      },
      "subtitle": {
        "type": "text",
        "default": "Enter your Application ID to view current status and merit list rank.",
        "control": "textarea",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "12px",
        "padding": "24px"
      }
    }
  },
  "AppProductCatalogBlock": {
    "type": "AppProductCatalogBlock",
    "title": "Inventory Catalog",
    "category": "erp_binding",
    "description": "Physical merchandise, uniform kits, or books catalog synchronized from inventory",
    "icon": "ShoppingBag",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Official Institute Merchandise & Study Kits",
        "control": "text",
        "group": "Content"
      },
      "category": {
        "type": "text",
        "default": "all",
        "control": "text",
        "group": "Advanced"
      },
      "inStockOnly": {
        "type": "boolean",
        "default": true,
        "control": "switch",
        "group": "Advanced"
      }
    },
    "styleControls": [
      "spacing",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "padding": "32px 16px"
      }
    }
  },
  "Button": {
    "type": "Button",
    "title": "Button",
    "category": "conversion",
    "description": "Interactive action button with multiple visual variants and page linking",
    "icon": "MousePointerClick",
    "version": "1.0.0",
    "props": {
      "text": {
        "type": "text",
        "default": "Click Here",
        "control": "text",
        "group": "Content"
      },
      "link": {
        "type": "link",
        "default": "#",
        "control": "link",
        "group": "Action"
      },
      "variant": {
        "type": "enum",
        "default": "primary",
        "options": [
          "primary",
          "secondary",
          "outline",
          "ghost"
        ],
        "control": "segmented",
        "group": "Style"
      },
      "size": {
        "type": "enum",
        "default": "md",
        "options": [
          "sm",
          "md",
          "lg"
        ],
        "control": "segmented",
        "group": "Style"
      },
      "fullWidth": {
        "type": "boolean",
        "default": false,
        "control": "switch",
        "group": "Layout"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {}
    },
    "presets": [
      {
        "name": "Primary Action",
        "props": {
          "text": "Enroll Now",
          "variant": "primary",
          "size": "lg"
        }
      }
    ]
  },
  "CallToActionBanner": {
    "type": "CallToActionBanner",
    "title": "Call-To-Action Banner",
    "category": "conversion",
    "description": "High-conversion banner with bold headline, value proposition, and prominent CTA button",
    "icon": "Megaphone",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Ready to Start Your Journey to a Top Rank?",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Register today for our diagnostic scholarship test and claim up to 90% fee waiver on all 2026/2027 entrance batches.",
        "control": "textarea",
        "group": "Content"
      },
      "ctaText": {
        "type": "text",
        "default": "Apply For Scholarship Test",
        "control": "text",
        "group": "Action"
      },
      "ctaLink": {
        "type": "text",
        "default": "/admissions#scholarship",
        "control": "link",
        "group": "Action"
      },
      "variant": {
        "type": "enum",
        "default": "primary",
        "options": [
          "primary",
          "dark",
          "outline"
        ],
        "control": "segmented",
        "group": "Style"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 32px 0"
      }
    },
    "presets": [
      {
        "name": "Scholarship Banner",
        "props": {
          "headline": "Scholarship Test Registrations Open"
        }
      }
    ]
  },
  "CoachCourseCatalogBlock": {
    "type": "CoachCourseCatalogBlock",
    "title": "Course Grid",
    "category": "erp_binding",
    "description": "Live courses and classroom batches synchronized from the Academics LMS Suite",
    "icon": "BookOpen",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Our Popular Courses",
        "control": "text",
        "group": "Content"
      },
      "grade": {
        "type": "text",
        "default": "all",
        "control": "text",
        "group": "Advanced"
      },
      "limit": {
        "type": "number",
        "default": 6,
        "control": "number",
        "group": "Advanced"
      }
    },
    "styleControls": [
      "spacing",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "padding": "32px 16px"
      }
    }
  },
  "ConsentCheckboxBlock": {
    "type": "ConsentCheckboxBlock",
    "title": "Consent Checkbox",
    "category": "legal",
    "description": "Granular consent checkbox with link for registration forms and newsletter signups",
    "icon": "CheckSquare",
    "version": "1.0.0",
    "props": {
      "label": {
        "type": "text",
        "default": "I agree to the Terms of Service and Privacy Policy",
        "control": "text",
        "group": "Compliance"
      },
      "policyLink": {
        "type": "link",
        "default": "/privacy-policy",
        "control": "link",
        "group": "Compliance"
      },
      "required": {
        "type": "boolean",
        "default": true,
        "control": "switch",
        "group": "Compliance"
      }
    },
    "styleControls": [
      "spacing"
    ],
    "defaultStyles": {
      "base": {
        "margin": "8px 0"
      }
    }
  },
  "Container": {
    "type": "Container",
    "title": "Container",
    "category": "layout",
    "description": "Responsive container box with max-width and centering controls",
    "icon": "Box",
    "version": "1.0.0",
    "container": true,
    "props": {
      "maxWidth": {
        "type": "string",
        "default": "1200px",
        "control": "select",
        "options": [
          "800px",
          "1024px",
          "1200px",
          "1440px",
          "100%"
        ],
        "group": "Layout"
      },
      "centered": {
        "type": "boolean",
        "default": true,
        "control": "switch",
        "group": "Layout"
      }
    },
    "styleControls": [
      "spacing",
      "background",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {
        "padding": "24px 16px"
      },
      "md": {
        "padding": "32px 24px"
      }
    },
    "presets": [
      {
        "name": "Default Container",
        "props": {
          "maxWidth": "1200px",
          "centered": true
        }
      }
    ]
  },
  "ConversionFormBlock": {
    "type": "ConversionFormBlock",
    "title": "Lead & Inquiry Form",
    "category": "conversion",
    "description": "High-converting inquiry and admission form with student details and direct CRM pipeline sync",
    "icon": "Send",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Request Free Counseling & Demo Class",
        "control": "text",
        "group": "Content"
      },
      "subtitle": {
        "type": "text",
        "default": "Fill out your details below and our academic counselor will contact you within 24 hours.",
        "control": "textarea",
        "group": "Content"
      },
      "submitButtonText": {
        "type": "text",
        "default": "Submit Inquiry",
        "control": "text",
        "group": "Action"
      },
      "formID": {
        "type": "text",
        "default": "inquiry-form-default",
        "control": "text",
        "group": "Advanced"
      },
      "targetAction": {
        "type": "text",
        "default": "/api/leads",
        "control": "text",
        "group": "Advanced"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "12px",
        "padding": "24px"
      }
    }
  },
  "CookieBannerBlock": {
    "type": "CookieBannerBlock",
    "title": "Cookie Banner & Compliance",
    "category": "legal",
    "description": "Compliant cookie preference notice banner with policy link and accept button",
    "icon": "Cookie",
    "version": "1.0.0",
    "props": {
      "noticeText": {
        "type": "text",
        "default": "We use cookies to improve your learning experience, remember preferences, and analyze site traffic.",
        "control": "textarea",
        "group": "Compliance"
      },
      "acceptButtonText": {
        "type": "text",
        "default": "Accept All",
        "control": "text",
        "group": "Compliance"
      },
      "declineButtonText": {
        "type": "text",
        "default": "Necessary Only",
        "control": "text",
        "group": "Compliance"
      },
      "cookiePolicyUrl": {
        "type": "link",
        "default": "/cookie-policy",
        "control": "link",
        "group": "Compliance"
      },
      "position": {
        "type": "enum",
        "default": "bottom",
        "options": [
          "bottom",
          "top"
        ],
        "control": "segmented",
        "group": "Compliance"
      }
    },
    "styleControls": [
      "spacing",
      "colors",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {
        "padding": "16px 24px"
      }
    }
  },
  "CountdownTimer": {
    "type": "CountdownTimer",
    "title": "Admissions Countdown",
    "category": "conversion",
    "description": "Urgency banner with live time blocks and direct registration CTA",
    "icon": "Clock",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Next Batch Admissions Closing Soon",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Last few seats remaining for JEE & NEET 2026/2027 entrance batches. Early registration fee scholarship applicable.",
        "control": "textarea",
        "group": "Content"
      },
      "days": {
        "type": "text",
        "default": "04",
        "control": "text",
        "group": "Content"
      },
      "hours": {
        "type": "text",
        "default": "18",
        "control": "text",
        "group": "Content"
      },
      "minutes": {
        "type": "text",
        "default": "35",
        "control": "text",
        "group": "Content"
      },
      "seconds": {
        "type": "text",
        "default": "40",
        "control": "text",
        "group": "Content"
      },
      "ctaText": {
        "type": "text",
        "default": "Reserve Your Seat Now",
        "control": "text",
        "group": "Action"
      },
      "ctaLink": {
        "type": "text",
        "default": "/admissions",
        "control": "link",
        "group": "Action"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 24px 0"
      }
    },
    "presets": [
      {
        "name": "Admissions Deadline",
        "props": {
          "headline": "Batch Starts In"
        }
      }
    ]
  },
  "DigitalProductCard": {
    "type": "DigitalProductCard",
    "title": "Digital Product Card",
    "category": "commerce",
    "description": "Showcase downloadable notes, formula sheets, mock test series, or digital guides with price and buy/download action",
    "icon": "Package",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Physics Formula Booklet (Class 12 & JEE)",
        "control": "text",
        "group": "Content"
      },
      "description": {
        "type": "text",
        "default": "Comprehensive formula summaries, high-yield shortcuts, and solved example problems.",
        "control": "textarea",
        "group": "Content"
      },
      "price": {
        "type": "number",
        "default": 299,
        "control": "number",
        "group": "Content"
      },
      "currency": {
        "type": "enum",
        "default": "INR",
        "options": [
          "INR",
          "USD",
          "EUR",
          "GBP"
        ],
        "control": "select",
        "group": "Content"
      },
      "fileType": {
        "type": "enum",
        "default": "PDF",
        "options": [
          "PDF",
          "EPUB",
          "Mock Test",
          "Video Pack",
          "ZIP Archive"
        ],
        "control": "select",
        "group": "Content"
      },
      "badge": {
        "type": "text",
        "default": "Instant Download",
        "control": "text",
        "group": "Content"
      },
      "thumbnail": {
        "type": "image",
        "default": "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600&auto=format&fit=crop&q=80",
        "control": "image",
        "group": "Content"
      },
      "downloadUrl": {
        "type": "link",
        "default": "#download",
        "control": "link",
        "group": "Action"
      },
      "buttonText": {
        "type": "text",
        "default": "Get Instant Access",
        "control": "text",
        "group": "Action"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "12px",
        "padding": "16px"
      }
    },
    "presets": [
      {
        "name": "Study Material Card",
        "props": {
          "title": "Complete Organic Chemistry Notes",
          "price": 499,
          "fileType": "PDF",
          "badge": "Bestseller"
        }
      }
    ]
  },
  "DigitalProductList": {
    "type": "DigitalProductList",
    "title": "Digital Products Grid",
    "category": "commerce",
    "description": "Grid display of downloadable digital study packs, e-books, and test material",
    "icon": "FolderArchive",
    "version": "1.0.0",
    "container": true,
    "props": {
      "sectionTitle": {
        "type": "text",
        "default": "Digital Study Materials & Downloads",
        "control": "text",
        "group": "Content"
      },
      "columns": {
        "type": "enum",
        "default": "3",
        "options": [
          "2",
          "3",
          "4"
        ],
        "control": "segmented",
        "group": "Layout"
      }
    },
    "styleControls": [
      "spacing",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "padding": "32px 16px"
      }
    }
  },
  "Divider": {
    "type": "Divider",
    "title": "Divider",
    "category": "layout",
    "description": "Horizontal separator line with customizable styling",
    "icon": "Minus",
    "version": "1.0.0",
    "props": {
      "thickness": {
        "type": "string",
        "default": "1px",
        "control": "select",
        "options": [
          "1px",
          "2px",
          "4px"
        ],
        "group": "Style"
      },
      "style": {
        "type": "enum",
        "default": "solid",
        "options": [
          "solid",
          "dashed",
          "dotted"
        ],
        "control": "segmented",
        "group": "Style"
      }
    },
    "styleControls": [
      "spacing",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "24px 0"
      }
    }
  },
  "FacultyShowcase": {
    "type": "FacultyShowcase",
    "title": "Faculty & Educators",
    "category": "academics",
    "description": "Grid of senior faculty members, subject specialties, qualifications, and pedagogical experience",
    "icon": "Users",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Meet Our Master Educators",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Learn from distinguished educators, ex-IITians, and subject masters dedicated to student rank achievement.",
        "control": "textarea",
        "group": "Content"
      },
      "faculty1_name": {
        "type": "text",
        "default": "Prof. Arvind Trivedi",
        "control": "text",
        "group": "Content"
      },
      "faculty1_subject": {
        "type": "text",
        "default": "Advanced Physics",
        "control": "text",
        "group": "Content"
      },
      "faculty1_qualification": {
        "type": "text",
        "default": "B.Tech IIT Kanpur (AIR 38)",
        "control": "text",
        "group": "Content"
      },
      "faculty1_exp": {
        "type": "text",
        "default": "18+ Years Exp",
        "control": "text",
        "group": "Content"
      },
      "faculty1_bio": {
        "type": "text",
        "default": "Mentor to 120+ Top 100 AIR rankers. Renowned for intuitive mechanics and electrodynamics visual problem solving.",
        "control": "textarea",
        "group": "Content"
      },
      "faculty2_name": {
        "type": "text",
        "default": "Dr. Meenakshi Sunder",
        "control": "text",
        "group": "Content"
      },
      "faculty2_subject": {
        "type": "text",
        "default": "Organic & Inorganic Chemistry",
        "control": "text",
        "group": "Content"
      },
      "faculty2_qualification": {
        "type": "text",
        "default": "Ph.D. IISc Bangalore",
        "control": "text",
        "group": "Content"
      },
      "faculty2_exp": {
        "type": "text",
        "default": "14+ Years Exp",
        "control": "text",
        "group": "Content"
      },
      "faculty2_bio": {
        "type": "text",
        "default": "Specializes in reaction mechanism mastery and mnemonics that make complex organic transformations effortless.",
        "control": "textarea",
        "group": "Content"
      },
      "faculty3_name": {
        "type": "text",
        "default": "Er. Rajesh Nair",
        "control": "text",
        "group": "Content"
      },
      "faculty3_subject": {
        "type": "text",
        "default": "Pure & Applied Mathematics",
        "control": "text",
        "group": "Content"
      },
      "faculty3_qualification": {
        "type": "text",
        "default": "M.Tech IIT Kharagpur",
        "control": "text",
        "group": "Content"
      },
      "faculty3_exp": {
        "type": "text",
        "default": "12+ Years Exp",
        "control": "text",
        "group": "Content"
      },
      "faculty3_bio": {
        "type": "text",
        "default": "Author of bestselling entrance problem sets in calculus, coordinate geometry, and combinatorial analysis.",
        "control": "textarea",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 32px 0"
      }
    },
    "presets": [
      {
        "name": "Teaching Staff",
        "props": {
          "headline": "Our Faculty Team"
        }
      }
    ]
  },
  "FeePaymentPortalBlock": {
    "type": "FeePaymentPortalBlock",
    "title": "Fee Payment Portal",
    "category": "erp_binding",
    "description": "Student dues lookup and secure payment portal linked directly with Suite S4 Fees",
    "icon": "Wallet",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Online Fee Payment & Installments",
        "control": "text",
        "group": "Content"
      },
      "allowOnlinePayment": {
        "type": "boolean",
        "default": true,
        "control": "switch",
        "group": "Action"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "12px",
        "padding": "24px"
      }
    }
  },
  "Grid2Col": {
    "type": "Grid2Col",
    "title": "2-Column Grid",
    "category": "layout",
    "description": "Two column responsive layout with configurable gap and stack-on-mobile behavior",
    "icon": "Columns",
    "version": "1.0.0",
    "container": true,
    "props": {
      "gap": {
        "type": "string",
        "default": "24px",
        "control": "select",
        "options": [
          "12px",
          "16px",
          "24px",
          "32px",
          "48px"
        ],
        "group": "Layout"
      }
    },
    "styleControls": [
      "spacing",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "display": "grid",
        "gap": "16px"
      },
      "md": {
        "gap": "24px"
      }
    },
    "presets": [
      {
        "name": "Standard 2-Column",
        "props": {
          "gap": "24px"
        }
      }
    ]
  },
  "Heading": {
    "type": "Heading",
    "title": "Heading",
    "category": "typography",
    "description": "Configurable heading tag H1-H6 with alignment and typography controls",
    "icon": "Heading",
    "version": "1.0.0",
    "props": {
      "text": {
        "type": "text",
        "default": "Headline Title",
        "control": "text",
        "group": "Content"
      },
      "level": {
        "type": "enum",
        "default": "h2",
        "options": [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6"
        ],
        "control": "segmented",
        "group": "Content"
      },
      "align": {
        "type": "enum",
        "default": "left",
        "options": [
          "left",
          "center",
          "right"
        ],
        "control": "segmented",
        "group": "Style"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 16px 0"
      }
    },
    "presets": [
      {
        "name": "Section Header",
        "props": {
          "text": "Our Flagship Programs",
          "level": "h2",
          "align": "center"
        }
      }
    ]
  },
  "HeroSplit": {
    "type": "HeroSplit",
    "title": "Hero Split",
    "category": "layout",
    "description": "Engaging hero banner with headline, call-to-action button, and showcase media",
    "icon": "Layout",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Empower Your Learning Journey",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Join thousands of successful students achieving top ranks with our comprehensive courses.",
        "control": "textarea",
        "group": "Content"
      },
      "ctaText": {
        "type": "text",
        "default": "Explore Courses",
        "control": "text",
        "group": "Action"
      },
      "ctaLink": {
        "type": "link",
        "default": "/courses",
        "control": "link",
        "group": "Action"
      },
      "imageURL": {
        "type": "image",
        "default": "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&auto=format&fit=crop&q=80",
        "control": "image",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "background",
      "border"
    ],
    "defaultStyles": {
      "base": {
        "padding": "40px 16px"
      },
      "md": {
        "padding": "64px 32px"
      }
    },
    "presets": [
      {
        "name": "Default Hero",
        "props": {
          "headline": "Achieve Your Academic Excellence",
          "subheadline": "Personalized coaching, expert faculty, and proven results.",
          "ctaText": "Get Started Today",
          "ctaLink": "#enroll"
        }
      }
    ]
  },
  "ImageGallery": {
    "type": "ImageGallery",
    "title": "Image Gallery",
    "category": "media",
    "description": "Responsive grid display of campus photos, classroom activities, and facilities",
    "icon": "Image",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Campus & Learning Facilities",
        "control": "text",
        "group": "Content"
      },
      "columns": {
        "type": "enum",
        "default": "3",
        "options": [
          "2",
          "3",
          "4"
        ],
        "control": "segmented",
        "group": "Layout"
      }
    },
    "styleControls": [
      "spacing",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "padding": "24px 16px"
      }
    }
  },
  "LegalAgreementBlock": {
    "type": "LegalAgreementBlock",
    "title": "Student Legal Agreement & Consent",
    "category": "legal",
    "description": "Student enrollment agreement with mandatory consent checkboxes for Terms & Conditions, Privacy Policy, and Cookie Policy",
    "icon": "ShieldCheck",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Terms & Policies Agreement",
        "control": "text",
        "group": "Compliance"
      },
      "agreementText": {
        "type": "text",
        "default": "By creating an account or enrolling, you agree to our policies:",
        "control": "text",
        "group": "Compliance"
      },
      "termsUrl": {
        "type": "link",
        "default": "/terms-and-conditions",
        "control": "link",
        "group": "Compliance"
      },
      "privacyUrl": {
        "type": "link",
        "default": "/privacy-policy",
        "control": "link",
        "group": "Compliance"
      },
      "cookieUrl": {
        "type": "link",
        "default": "/cookie-policy",
        "control": "link",
        "group": "Compliance"
      },
      "requireMarketingConsent": {
        "type": "boolean",
        "default": false,
        "control": "switch",
        "group": "Compliance"
      },
      "marketingConsentText": {
        "type": "text",
        "default": "I agree to receive SMS, WhatsApp, and email updates regarding classes and exam schedules.",
        "control": "textarea",
        "group": "Compliance"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "8px",
        "padding": "16px"
      }
    },
    "presets": [
      {
        "name": "Standard Student Consent",
        "props": {
          "termsUrl": "/terms",
          "privacyUrl": "/privacy"
        }
      }
    ]
  },
  "MathFormulaBlock": {
    "type": "MathFormulaBlock",
    "title": "Math Formula",
    "category": "typography",
    "description": "Scientific and mathematical LaTeX equation renderer with display or inline modes",
    "icon": "Binary",
    "version": "1.0.0",
    "props": {
      "latex": {
        "type": "text",
        "default": "\\int_{-\\infty}^{\\infty} e^{-x^2} dx = \\sqrt{\\pi}",
        "control": "text",
        "group": "Content"
      },
      "display": {
        "type": "boolean",
        "default": true,
        "control": "switch",
        "group": "Style"
      }
    },
    "styleControls": [
      "spacing",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "16px 0",
        "text-align": "center"
      }
    },
    "presets": [
      {
        "name": "Gaussian Integral",
        "props": {
          "latex": "\\int_{-\\infty}^{\\infty} e^{-x^2} dx = \\sqrt{\\pi}",
          "display": true
        }
      }
    ]
  },
  "Paragraph": {
    "type": "Paragraph",
    "title": "Paragraph",
    "category": "typography",
    "description": "Text paragraph with responsive typography and font sizing",
    "icon": "AlignLeft",
    "version": "1.0.0",
    "props": {
      "text": {
        "type": "text",
        "default": "Add your descriptive text here. Share information about your coaching center, courses, and guidance.",
        "control": "textarea",
        "group": "Content"
      },
      "size": {
        "type": "enum",
        "default": "base",
        "options": [
          "sm",
          "base",
          "lg"
        ],
        "control": "segmented",
        "group": "Style"
      },
      "align": {
        "type": "enum",
        "default": "left",
        "options": [
          "left",
          "center",
          "right"
        ],
        "control": "segmented",
        "group": "Style"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 12px 0"
      }
    }
  },
  "PricingTable": {
    "type": "PricingTable",
    "title": "Pricing & Course Fee Table",
    "category": "commerce",
    "description": "3-tier fee comparison table with feature bullets, badges, and enrollment buttons",
    "icon": "CreditCard",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Transparent Course Packages",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Choose the program tailored for your target exam and learning schedule.",
        "control": "textarea",
        "group": "Content"
      },
      "tier1_title": {
        "type": "text",
        "default": "Foundation Track",
        "control": "text",
        "group": "Content"
      },
      "tier1_price": {
        "type": "text",
        "default": "₹24,999",
        "control": "text",
        "group": "Content"
      },
      "tier1_period": {
        "type": "text",
        "default": "/ year",
        "control": "text",
        "group": "Content"
      },
      "tier1_badge": {
        "type": "text",
        "default": "Class 9 - 10",
        "control": "text",
        "group": "Content"
      },
      "tier1_features": {
        "type": "text",
        "default": "Math & Science Core, Weekly Unit Tests, Digital Study Notes, Mentor Guidance",
        "control": "textarea",
        "group": "Content"
      },
      "tier1_ctaText": {
        "type": "text",
        "default": "Enroll in Foundation",
        "control": "text",
        "group": "Action"
      },
      "tier1_ctaLink": {
        "type": "text",
        "default": "/checkout?plan=foundation",
        "control": "link",
        "group": "Action"
      },
      "tier2_title": {
        "type": "text",
        "default": "Target Entrance (JEE/NEET)",
        "control": "text",
        "group": "Content"
      },
      "tier2_price": {
        "type": "text",
        "default": "₹59,999",
        "control": "text",
        "group": "Content"
      },
      "tier2_period": {
        "type": "text",
        "default": "/ year",
        "control": "text",
        "group": "Content"
      },
      "tier2_badge": {
        "type": "text",
        "default": "Most Popular",
        "control": "text",
        "group": "Content"
      },
      "tier2_features": {
        "type": "text",
        "default": "Ex-IITian Live Lectures, Daily Practice Problems (DPP), All-India Test Series, 1-on-1 Doubt Solving, AIIMS/JEE Question Bank",
        "control": "textarea",
        "group": "Content"
      },
      "tier2_ctaText": {
        "type": "text",
        "default": "Join Target Batch",
        "control": "text",
        "group": "Action"
      },
      "tier2_ctaLink": {
        "type": "text",
        "default": "/checkout?plan=target",
        "control": "link",
        "group": "Action"
      },
      "tier3_title": {
        "type": "text",
        "default": "Rankers Super 30",
        "control": "text",
        "group": "Content"
      },
      "tier3_price": {
        "type": "text",
        "default": "₹89,999",
        "control": "text",
        "group": "Content"
      },
      "tier3_period": {
        "type": "text",
        "default": "/ year",
        "control": "text",
        "group": "Content"
      },
      "tier3_badge": {
        "type": "text",
        "default": "Interview Required",
        "control": "text",
        "group": "Content"
      },
      "tier3_features": {
        "type": "text",
        "default": "Top Batch Faculty, Dedicated Personal Coach, Advanced Problem Solving, Full Test Analysis, Hostel & Library Access",
        "control": "textarea",
        "group": "Content"
      },
      "tier3_ctaText": {
        "type": "text",
        "default": "Apply for Super 30",
        "control": "text",
        "group": "Action"
      },
      "tier3_ctaLink": {
        "type": "text",
        "default": "/admissions?plan=super30",
        "control": "link",
        "group": "Action"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 32px 0"
      }
    },
    "presets": [
      {
        "name": "Course Pricing",
        "props": {
          "headline": "Tuition & Entrance Fees"
        }
      }
    ]
  },
  "RichTextBlock": {
    "type": "RichTextBlock",
    "title": "Rich Text",
    "category": "typography",
    "description": "Formatted HTML text block supporting headings, bullet points, and styled content",
    "icon": "FileText",
    "version": "1.0.0",
    "props": {
      "contentHTML": {
        "type": "richtext",
        "default": "<p>Welcome to our online coaching portal. Here you can find comprehensive syllabus coverage, video lectures, and practice modules.</p>",
        "control": "textarea",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 16px 0"
      }
    }
  },
  "SchoolNoticeBoardBlock": {
    "type": "SchoolNoticeBoardBlock",
    "title": "Notice Board",
    "category": "erp_binding",
    "description": "Live circulars and notices synchronized from the Communication Suite",
    "icon": "Bell",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Latest Notices & Circulars",
        "control": "text",
        "group": "Content"
      },
      "category": {
        "type": "text",
        "default": "general",
        "control": "text",
        "group": "Advanced"
      },
      "limit": {
        "type": "number",
        "default": 5,
        "control": "number",
        "group": "Advanced"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "12px",
        "padding": "24px"
      }
    }
  },
  "Section": {
    "type": "Section",
    "title": "Page Section",
    "category": "layout",
    "description": "Full-width semantic section container with background color, padding, and layout bounds",
    "icon": "Layers",
    "version": "1.0.0",
    "container": true,
    "props": {
      "sectionId": {
        "type": "text",
        "default": "",
        "control": "text",
        "group": "Advanced"
      }
    },
    "styleControls": [
      "spacing",
      "background",
      "border"
    ],
    "defaultStyles": {
      "base": {
        "padding": "48px 16px"
      },
      "md": {
        "padding": "64px 32px"
      }
    }
  },
  "SiteFooter": {
    "type": "SiteFooter",
    "title": "Site Footer",
    "category": "layout",
    "description": "Permanent footer with student portal links, contact information, legal pages, and copyright",
    "icon": "PanelBottom",
    "version": "1.0.0",
    "props": {
      "variant": {
        "type": "enum",
        "default": "multicolumn",
        "control": "select",
        "options": [
          "multicolumn",
          "centered",
          "newsletter",
          "dark",
          "compact"
        ],
        "group": "Style"
      },
      "brandName": {
        "type": "text",
        "default": "Apex Coaching Academy",
        "control": "text",
        "group": "Content"
      },
      "description": {
        "type": "text",
        "default": "Premier coaching institute empowering students to achieve top national ranks in JEE, NEET, and Olympiad examinations.",
        "control": "textarea",
        "group": "Content"
      },
      "address": {
        "type": "text",
        "default": "Knowledge Park, Sector 62, New Delhi - 110001",
        "control": "text",
        "group": "Content"
      },
      "phone": {
        "type": "text",
        "default": "+91 98765 43210",
        "control": "text",
        "group": "Content"
      },
      "email": {
        "type": "text",
        "default": "admissions@academy.edu.in",
        "control": "text",
        "group": "Content"
      },
      "copyrightText": {
        "type": "text",
        "default": "© 2026 All Rights Reserved.",
        "control": "text",
        "group": "Content"
      },
      "bgColor": {
        "type": "color",
        "default": "#0f172a",
        "control": "color",
        "group": "Style"
      },
      "textColor": {
        "type": "color",
        "default": "#f8fafc",
        "control": "color",
        "group": "Style"
      },
      "accentColor": {
        "type": "color",
        "default": "#3b82f6",
        "control": "color",
        "group": "Style"
      }
    },
    "styleControls": [
      "background",
      "border",
      "typography"
    ],
    "defaultStyles": {
      "base": {
        "padding": "48px 24px 24px"
      }
    }
  },
  "SiteNavbar": {
    "type": "SiteNavbar",
    "title": "Site Navigation Bar",
    "category": "layout",
    "description": "Permanent header navigation bar with brand, live student page links, and enrollment CTA",
    "icon": "Menu",
    "version": "1.0.0",
    "props": {
      "variant": {
        "type": "enum",
        "default": "classic",
        "control": "select",
        "options": [
          "classic",
          "centered",
          "glass",
          "split",
          "dark",
          "minimal"
        ],
        "group": "Style"
      },
      "brandName": {
        "type": "text",
        "default": "Apex Coaching Academy",
        "control": "text",
        "group": "Content"
      },
      "logoText": {
        "type": "text",
        "default": "AC",
        "control": "text",
        "group": "Content"
      },
      "logoUrl": {
        "type": "image",
        "default": "",
        "control": "image",
        "group": "Content"
      },
      "tagline": {
        "type": "text",
        "default": "IIT-JEE · NEET · Foundation",
        "control": "text",
        "group": "Content"
      },
      "ctaText": {
        "type": "text",
        "default": "Student Login / Enroll",
        "control": "text",
        "group": "Action"
      },
      "ctaLink": {
        "type": "link",
        "default": "#enroll",
        "control": "link",
        "group": "Action"
      },
      "phone": {
        "type": "text",
        "default": "+91 98765 43210",
        "control": "text",
        "group": "Content"
      },
      "sticky": {
        "type": "boolean",
        "default": true,
        "control": "switch",
        "group": "Layout"
      },
      "accentColor": {
        "type": "color",
        "default": "#2563eb",
        "control": "color",
        "group": "Style"
      },
      "bgColor": {
        "type": "color",
        "default": "#ffffff",
        "control": "color",
        "group": "Style"
      },
      "textColor": {
        "type": "color",
        "default": "#0f172a",
        "control": "color",
        "group": "Style"
      }
    },
    "styleControls": [
      "background",
      "border",
      "typography"
    ],
    "defaultStyles": {
      "base": {
        "padding": "12px 24px"
      }
    }
  },
  "Spacer": {
    "type": "Spacer",
    "title": "Spacer",
    "category": "layout",
    "description": "Vertical blank space to control spacing between sections",
    "icon": "MoveVertical",
    "version": "1.0.0",
    "props": {
      "height": {
        "type": "string",
        "default": "40px",
        "control": "select",
        "options": [
          "16px",
          "24px",
          "32px",
          "40px",
          "64px",
          "96px"
        ],
        "group": "Layout"
      }
    },
    "styleControls": [
      "spacing"
    ],
    "defaultStyles": {
      "base": {
        "height": "40px"
      }
    }
  },
  "StatsCounter": {
    "type": "StatsCounter",
    "title": "Statistics & Achievements",
    "category": "conversion",
    "description": "High-impact 4-metric achievements counter highlighting ranks, percentile, and selections",
    "icon": "TrendingUp",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Our Legacy in Numbers",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Consistent results year after year across national competitive benchmarks.",
        "control": "textarea",
        "group": "Content"
      },
      "stat1_value": {
        "type": "text",
        "default": "99.8%",
        "control": "text",
        "group": "Content"
      },
      "stat1_label": {
        "type": "text",
        "default": "Top JEE & NEET Percentile",
        "control": "text",
        "group": "Content"
      },
      "stat2_value": {
        "type": "text",
        "default": "2,450+",
        "control": "text",
        "group": "Content"
      },
      "stat2_label": {
        "type": "text",
        "default": "Selections in Govt Colleges",
        "control": "text",
        "group": "Content"
      },
      "stat3_value": {
        "type": "text",
        "default": "48+",
        "control": "text",
        "group": "Content"
      },
      "stat3_label": {
        "type": "text",
        "default": "AIR Top 100 Ranks",
        "control": "text",
        "group": "Content"
      },
      "stat4_value": {
        "type": "text",
        "default": "16+",
        "control": "text",
        "group": "Content"
      },
      "stat4_label": {
        "type": "text",
        "default": "Years of Pedagogy Excellence",
        "control": "text",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 24px 0"
      }
    },
    "presets": [
      {
        "name": "Achievement Metrics",
        "props": {
          "headline": "Results That Speak"
        }
      }
    ]
  },
  "StorefrontCheckoutBlock": {
    "type": "StorefrontCheckoutBlock",
    "title": "Storefront Checkout Button",
    "category": "commerce",
    "description": "Direct enrollment and one-click purchase checkout trigger for courses and packages",
    "icon": "CreditCard",
    "version": "1.0.0",
    "props": {
      "itemType": {
        "type": "enum",
        "default": "course",
        "options": [
          "course",
          "test_series",
          "digital_product",
          "batch_enrollment"
        ],
        "control": "select",
        "group": "Action"
      },
      "itemRefID": {
        "type": "text",
        "default": "default-item",
        "control": "text",
        "group": "Action"
      },
      "buttonLabel": {
        "type": "text",
        "default": "Enroll Now",
        "control": "text",
        "group": "Content"
      },
      "priceDisplay": {
        "type": "text",
        "default": "₹4,999",
        "control": "text",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {}
    }
  },
  "Testimonials": {
    "type": "Testimonials",
    "title": "Testimonials Showcase",
    "category": "academics",
    "description": "Student and parent reviews with star ratings, quotes, and exam score badges",
    "icon": "MessageSquare",
    "version": "1.0.0",
    "props": {
      "headline": {
        "type": "text",
        "default": "Success Stories from Our Rankers",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Hear how our structured pedagogy and mentoring helped students crack top national entrance exams.",
        "control": "textarea",
        "group": "Content"
      },
      "testimonial1_name": {
        "type": "text",
        "default": "Rohan Deshmukh",
        "control": "text",
        "group": "Content"
      },
      "testimonial1_role": {
        "type": "text",
        "default": "AIR 42 • JEE Advanced 2025",
        "control": "text",
        "group": "Content"
      },
      "testimonial1_quote": {
        "type": "text",
        "default": "The daily DPPs and rigorous doubt sessions at Helios Academy helped me master organic chemistry and physics concepts with crystal clarity.",
        "control": "textarea",
        "group": "Content"
      },
      "testimonial1_badge": {
        "type": "text",
        "default": "IIT Bombay CSE",
        "control": "text",
        "group": "Content"
      },
      "testimonial2_name": {
        "type": "text",
        "default": "Ananya Sharma",
        "control": "text",
        "group": "Content"
      },
      "testimonial2_role": {
        "type": "text",
        "default": "Score: 710/720 • NEET UG 2025",
        "control": "text",
        "group": "Content"
      },
      "testimonial2_quote": {
        "type": "text",
        "default": "The faculty treated my weaknesses as their own. Personal feedback on mock tests made all the difference on the final exam day.",
        "control": "textarea",
        "group": "Content"
      },
      "testimonial2_badge": {
        "type": "text",
        "default": "AIIMS New Delhi",
        "control": "text",
        "group": "Content"
      },
      "testimonial3_name": {
        "type": "text",
        "default": "Dr. Sunil Varma (Parent)",
        "control": "text",
        "group": "Content"
      },
      "testimonial3_role": {
        "type": "text",
        "default": "Father of Kshitij Varma (AIR 104)",
        "control": "text",
        "group": "Content"
      },
      "testimonial3_quote": {
        "type": "text",
        "default": "As a parent, the constant attendance alerts, progress reports, and mentor guidance gave us total peace of mind throughout the 2-year preparation.",
        "control": "textarea",
        "group": "Content"
      },
      "testimonial3_badge": {
        "type": "text",
        "default": "Parent Review",
        "control": "text",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "typography",
      "colors"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 32px 0"
      }
    },
    "presets": [
      {
        "name": "Student Testimonials",
        "props": {
          "headline": "Student & Parent Reviews"
        }
      }
    ]
  },
  "TopperCard": {
    "type": "TopperCard",
    "title": "Topper Achievement Card",
    "category": "academics",
    "description": "Highlight top performing student with photo, rank badge, exam name, score, and testimonial",
    "icon": "Award",
    "version": "1.0.0",
    "props": {
      "studentName": {
        "type": "text",
        "default": "Aarav Sharma",
        "control": "text",
        "group": "Content"
      },
      "examName": {
        "type": "text",
        "default": "JEE Advanced 2025",
        "control": "text",
        "group": "Content"
      },
      "rank": {
        "type": "text",
        "default": "AIR 42",
        "control": "text",
        "group": "Content"
      },
      "score": {
        "type": "text",
        "default": "Score: 312/360",
        "control": "text",
        "group": "Content"
      },
      "photoUrl": {
        "type": "image",
        "default": "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&auto=format&fit=crop&q=80",
        "control": "image",
        "group": "Content"
      },
      "testimonial": {
        "type": "text",
        "default": "The structured test series and mentorship were pivotal in my rank preparation.",
        "control": "textarea",
        "group": "Content"
      },
      "batchYear": {
        "type": "text",
        "default": "Class of 2025",
        "control": "text",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow",
      "background"
    ],
    "defaultStyles": {
      "base": {
        "border-radius": "16px",
        "padding": "20px"
      }
    },
    "presets": [
      {
        "name": "JEE Ranker",
        "props": {
          "studentName": "Priya Patel",
          "examName": "NEET 2025",
          "rank": "AIR 15",
          "score": "710/720"
        }
      }
    ]
  },
  "ToppersShowcase": {
    "type": "ToppersShowcase",
    "title": "Toppers Showcase & Hall of Fame",
    "category": "academics",
    "description": "Hall of fame section showcasing student ranks, results, and national achievement records",
    "icon": "Trophy",
    "version": "1.0.0",
    "container": true,
    "props": {
      "headline": {
        "type": "text",
        "default": "Our Star Performers & Toppers",
        "control": "text",
        "group": "Content"
      },
      "subheadline": {
        "type": "text",
        "default": "Celebrating the outstanding ranks and hard work of our dedicated students in national competitive examinations.",
        "control": "textarea",
        "group": "Content"
      },
      "badgeText": {
        "type": "text",
        "default": "Hall of Fame 2025",
        "control": "text",
        "group": "Content"
      }
    },
    "styleControls": [
      "spacing",
      "background",
      "border"
    ],
    "defaultStyles": {
      "base": {
        "padding": "48px 16px"
      }
    }
  },
  "VideoPlayer": {
    "type": "VideoPlayer",
    "title": "Video Lecture & Tour",
    "category": "media",
    "description": "Embedded responsive video player for classroom walkthroughs, sample lectures, and director messages",
    "icon": "Video",
    "version": "1.0.0",
    "props": {
      "title": {
        "type": "text",
        "default": "Inside Helios Coach: Campus Walkthrough & Faculty Orientation",
        "control": "text",
        "group": "Content"
      },
      "videoURL": {
        "type": "text",
        "default": "https://www.youtube-nocookie.com/embed/dQw4w9WgXcQ",
        "control": "text",
        "group": "Content"
      },
      "caption": {
        "type": "text",
        "default": "Watch our founder discuss our 2-year entrance preparation pedagogy and mentorship system.",
        "control": "textarea",
        "group": "Content"
      },
      "aspectRatio": {
        "type": "enum",
        "default": "16:9",
        "options": [
          "16:9",
          "4:3",
          "1:1"
        ],
        "control": "segmented",
        "group": "Style"
      }
    },
    "styleControls": [
      "spacing",
      "border",
      "shadow"
    ],
    "defaultStyles": {
      "base": {
        "margin": "0 0 24px 0"
      }
    },
    "presets": [
      {
        "name": "Demo Lecture",
        "props": {
          "title": "Physics Orientation Lecture"
        }
      }
    ]
  }
};

export const ALL_BLOCK_TYPES: BlockType[] = [
  'AccordionFAQ',
  'AdmissionsStatusTrackerBlock',
  'AppProductCatalogBlock',
  'Button',
  'CallToActionBanner',
  'CoachCourseCatalogBlock',
  'ConsentCheckboxBlock',
  'Container',
  'ConversionFormBlock',
  'CookieBannerBlock',
  'CountdownTimer',
  'DigitalProductCard',
  'DigitalProductList',
  'Divider',
  'FacultyShowcase',
  'FeePaymentPortalBlock',
  'Grid2Col',
  'Heading',
  'HeroSplit',
  'ImageGallery',
  'LegalAgreementBlock',
  'MathFormulaBlock',
  'Paragraph',
  'PricingTable',
  'RichTextBlock',
  'SchoolNoticeBoardBlock',
  'Section',
  'SiteFooter',
  'SiteNavbar',
  'Spacer',
  'StatsCounter',
  'StorefrontCheckoutBlock',
  'Testimonials',
  'TopperCard',
  'ToppersShowcase',
  'VideoPlayer',
];

export function getBlockManifest(type: string): BlockManifest | undefined {
  return (BLOCK_MANIFESTS as Record<string, BlockManifest>)[type];
}
